import { UiVideoModel } from "../../models";

import { mock$AssetModel } from "./mock-asset";

export function mockUiVideoModel({
    id = "video-1234",
    type = "uiVideo",
    locale = "en",
    content = mockUiVideoModelContent()
}: Partial<UiVideoModel> = {}): UiVideoModel {
    return {
        id,
        type,
        locale,
        content
    };
}

export type UiVideoModelContent = UiVideoModel["content"];

export function mockUiVideoModelContent({
    poster = mock$AssetModel(),
    ...optionals
}: Partial<UiVideoModelContent> = {}): UiVideoModelContent {
    return {
        title: "Test video title",
        poster,
        ...optionals
    };
}
